/** Petit bandeau neutre en haut (code ignoré, QR code) ; traversable, il ne bloque rien. */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export type NoticeInfo = { text: string; ms: number };

export function ScanNotice({ notice }: { notice: NoticeInfo | null }) {
  const [shown, setShown] = useState<NoticeInfo | null>(null);
  useEffect(() => {
    if (!notice) return undefined;
    setShown(notice);
    const timer = setTimeout(() => setShown(null), notice.ms);
    return () => clearTimeout(timer);
  }, [notice]);
  if (!shown) return null;
  return createPortal(
    <div
      role="status"
      data-testid="scan-notice"
      className="pointer-events-none fixed inset-x-3 top-16 z-[60] rounded-xl bg-neutral-700 px-4 py-3 text-center text-base font-semibold text-white shadow-xl"
    >
      {shown.text}
    </div>,
    document.body,
  );
}
